/**
 * This file contains utilities for units
 */

export const getUnit = (unitID, unitObj) => ({[unitID]: unitObj});
export const getUnitID = (unit) => Object.keys(unit)[0];
export const getUnitObj = (unit) => unit[getUnitID(unit)];
export const getUnitName = (unit) => unit[getUnitID(unit)].carName;
export const getUnitElevation = (unit) => unit[getUnitID(unit)].elevation;
export const getUnitLatitude = (unit) => unit[getUnitID(unit)].latitude;
export const getUnitLongitude = (unit) => unit[getUnitID(unit)].longitude;
export const getUnitSecurityStatus = (unit) => unit[getUnitID(unit)].securityEnabled;
export const getUnitLiveStreamStatus = (unit) => unit[getUnitID(unit)].liveStreamStatus;
export const getUnitLiveStreamURL = (unit) => unit[getUnitID(unit)].liveStreamURL;



// WEBPACK FOOTER //
// ./src/components/unit/utils.js